<template>
  <div class="log-detail-container">
    <div class="header-actions" v-if="logDetail && logDetail.flowStatus === '1'">
      <van-button round type="info" size="small" icon="edit" @click="onEdit">
        修改
      </van-button>
      <van-button round type="danger" size="small" icon="delete" @click="onDelete">
        删除
      </van-button>
      <van-button round type="primary" size="small" icon="success" @click="onSubmit">
        送审
      </van-button>
    </div>

    <div class="content-wrapper" v-if="logDetail">
      <div class="date-section">
        <div class="date-value">{{ logDetail.workDate }} <span class="weekday-text">{{ weekdayStr }}</span></div>
      </div>

      <div class="section-title">{{ logDetail.dailyType === '1' ? '当日主要工作完成情况' : '工程形象进度' }}</div>
      <div class="section-content">{{ logDetail.workContent }}</div>

      <div class="section-title">{{ logDetail.dailyType === '1' ? '需协调事宜或工作心得' : '工程质量情况' }}</div>
      <div class="section-content">
        <span v-if="logDetail.workContent1">{{ logDetail.workContent1 }}</span>
        <span v-else class="empty-tip">暂无内容</span>
      </div>

      <div class="section-title">{{ logDetail.dailyType === '1' ? '明日工作提示' : '安全生产' }}</div>
      <div class="section-content">
        <span v-if="logDetail.workContent2">{{ logDetail.workContent2 }}</span>
        <span v-else class="empty-tip">暂无内容</span>
      </div>

      <template v-if="logDetail.dailyType === '2'">
        <div class="section-title">甲供材进场记录</div>
        <div class="section-content">
          <span v-if="logDetail.workContent3">{{ logDetail.workContent3 }}</span>
          <span v-else class="empty-tip">暂无内容</span>
        </div>
      </template>

      <template v-if="logDetail.attachList && logDetail.attachList.length > 0">
        <div class="section-title">附件</div>
        <div class="attachment-card">
          <div class="attachment-list">
            <div
              v-for="(file, index) in logDetail.attachList"
              :key="index"
              class="attachment-item"
              @click="$viewAttach(file)"
            >
              <van-icon name="description" size="24" color="#0089FF" />
              <div class="attachment-name">{{ file.name }}</div>
              <van-icon name="arrow" size="16" color="#8c8c8c" />
            </div>
          </div>
        </div>
      </template>

      <div class="info-section" v-if="logDetail.flowStatus !== '1'">
        <!-- <div class="info-item" v-if="logDetail.flowStatus === '1'">
          <span class="label">审核状态：</span>
          <span :class="'status status-' + logDetail.flowStatus">{{ statusMap[logDetail.flowStatus] }}</span>
        </div> -->
        <process-record :procInsId="logDetail.procInsId"></process-record>
      </div>
    </div>

    <van-empty v-else description="暂无数据" />

    <van-popup v-model="showFlowPicker" position="bottom" round>
      <van-picker
          :columns="flowColumns"
          show-toolbar
          title="选择送审流程"
          @cancel="showFlowPicker = false"
          @confirm="onFlowConfirm"
      >
        <template #option="{NAME_}">
          {{ NAME_ }}
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
import DailyLogService from '@/api/dailyLog/DailyLogService.js'
import processRecord from "@/components/processRecord/processRecord";

export default {
  name: 'LogDetail',
  data() {
    return {
      logDetail: null,
      weekdayStr: '',
      statusMap: {
        '1': '未审核',
        '2': '审核中',
        '3': '已审核'
      },
      flowList: [],
      showFlowPicker: false
    }
  },
  computed: {
    flowColumns() {
      return [
        {
          values: this.flowList,
          defaultIndex: 0
        }
      ]
    }
  },
  created() {
    this.loadLogDetail()
  },
  components: {
    processRecord
  },
  methods: {
    loadLogDetail() {
      const id = this.$route.query.id
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })

      new DailyLogService().view(id).then(res => {
        this.$toast.clear()
        this.logDetail = res.data
        if(!res.data.attachList) {
           this.logDetail.attachList = []
        }
        this.weekdayStr = this.getWeekdayStr(res.data.workDate)
        // 日志详情加载完成后再获取流程列表
        this.getFlowList()
      }).catch(err => {
        this.$toast.fail('加载失败')
      })
    },
    getFlowList() {
      const permission = this.logDetail && this.logDetail.dailyType === '1' ? 'cms:work:daily:01:flow' : 'cms:work:daily:02:flow'

      new DailyLogService().queryByProjectAndPermission('', permission).then(res => {
        this.flowList = res.data || []
      }).catch(err => {
        this.flowList = []
      })
    },
    onEdit() {
      this.$router.push({
        path: '/dailyLog/edit',
        query: {
          id: this.logDetail.id,
          type: this.logDetail.dailyType
        }
      })
    },
    onDelete() {
      this.$dialog.confirm({
        title: '确认删除',
        message: '确认删除该日志吗？'
      }).then(() => {
        this.$toast.loading({
          message: '删除中...',
          forbidClick: true
        })

        new DailyLogService().delete(this.logDetail.id).then(res => {
          this.$toast.clear()
          this.$toast.success('删除成功')
          setTimeout(() => {
            this.$router.back()
          }, 500)
        }).catch(err => {
          this.$toast.fail('删除失败')
        })
      }).catch(() => {})
    },
    onSubmit() {
      this.showFlowPicker = true
    },
    async onFlowConfirm(value) {
      this.showFlowPicker = false

      try {
        await this.$dialog.confirm({
          title: '确认提交',
          message: `确认送审这条日志吗？`
        })

        this.$toast.loading({
          message: '提交中...',
          forbidClick: true
        })

        await new DailyLogService().getTaskDef({
          procDefId: value[0].ID_,
          status: 'start'
        })

        const flowData = {
          id: this.logDetail.id,
          formKey: '/erp/cms/work/daily/01/CmsWorkDailyFormFlow',
          flowType: 1,
          flowTable: 'cms_work_daily'
        }

        const hasDingAccount = await new DailyLogService().hasDingAccount()

        if (hasDingAccount.data === 'none') {
          const confirm = await this.$dialog.confirm({
            title: '确认送审',
            message: '当前用户未绑定钉钉账号，是否继续送审？'
          })
          if (!confirm) {
            return
          }
        }

        await this.submitFlow(value, flowData)

        this.$toast.success('送审成功')

        setTimeout(() => {
          this.resetAfterSubmit()
        }, 1500)

      } catch (err) {
        this.$toast.fail('提交失败')
      }
    },
    async submitFlow(value, flowData) {
      const service = new DailyLogService()
      await service.startFlow(flowData)

      const logTypeText = this.logDetail.dailyType === '1' ? '工作日记' : '工程日志'
      const flowTitle = this.logDetail.workDate.replace(/-/g, "") + "-" + this.logDetail.employeeName

      await service.start({
        procDefKey: value[0].KEY_,
        businessTable: 'cms_work_daily',
        businessId: this.logDetail.id,
        isMobile: 1,
        employeeId: this.logDetail.employeeId,
        deptId: this.logDetail.deptId,
        companyId: this.logDetail.companyId,
        title: '企业管理-' + logTypeText + '-' + flowTitle,
        assignee: '',
        vars: {
          employeeId: this.logDetail.employeeId,
          deptId: this.logDetail.deptId,
          companyId: this.logDetail.companyId,
          title: '企业管理-' + logTypeText + '-' + flowTitle,
          assignee: '',
          isMobile: 1,
        }
      })
    },
    resetAfterSubmit() {
      this.showFlowPicker = false
      this.loadLogDetail()
    },
    getWeekdayStr(date) {
      const weekdays = ['日', '一', '二', '三', '四', '五', '六']
      const day = moment(date).day()
      return `星期${weekdays[day]}`
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@400;500;600;700&display=swap');

.log-detail-container {
  min-height: 100vh;
  background: #fafbfc;
  font-family: 'Source Sans 3', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.header-actions {
  background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%);
  padding: 14px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  position: sticky;
  top: 0;
  z-index: 99;
  border-bottom: 1px solid rgba(0, 137, 255, 0.08);
}

.header-actions .van-button {
  border-radius: 12px;
  font-weight: 600;
  transition: all 0.25s ease;
}

.header-actions .van-button--info {
  background: linear-gradient(135deg, #0089FF 0%, #0070E0 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(0, 137, 255, 0.2);
}

.header-actions .van-button--info:hover {
  box-shadow: 0 4px 12px rgba(0, 137, 255, 0.3);
  transform: translateY(-1px);
}

.header-actions .van-button--danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.2);
}

.header-actions .van-button--danger:hover {
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
  transform: translateY(-1px);
}

.header-actions .van-button--primary {
  background: linear-gradient(135deg, #22C55E 0%, #16a34a 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(34, 197, 94, 0.2);
}

.header-actions .van-button--primary:hover {
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);
  transform: translateY(-1px);
}

.content-wrapper {
  padding: 20px 16px;
  padding-bottom: 80px;
}

.date-section {
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.date-value {
  font-size: 22px;
  color: #1a2332;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.weekday-text {
  font-size: 22px;
  font-weight: 600;
  color: #1a2332;
  margin-left: 6px;
}

.section-title {
  font-size: 17px;
  font-weight: 600;
  color: #1a2332;
  margin: 20px 0 12px 0;
  letter-spacing: 0.3px;
}

.section-content {
  background: #ffffff;
  padding: 18px;
  border-radius: 12px;
  font-size: 16px;
  color: #64748b;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-all;
  min-height: 80px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.empty-tip {
  color: #94a3b8;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
}

.info-section {
  background: #ffffff;
  border-radius: 12px;
  padding: 18px;
  margin-top: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.attachment-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.attachment-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.attachment-item {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  background: #f7f8fa;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  transition: all 0.2s ease;
  cursor: pointer;
}

.attachment-item:active {
  background: #f0f1f3;
}

.attachment-name {
  flex: 1;
  font-size: 16px;
  color: #1a2332;
  margin: 0 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.label {
  color: #64748b;
  margin-right: 8px;
}

.value {
  color: #1a2332;
}

.status {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.status.status-1 {
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  color: #ea580c;
  border: 1px solid rgba(234, 88, 12, 0.2);
}

.status.status-2 {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #0089FF;
  border: 1px solid rgba(0, 137, 255, 0.2);
}

.status.status-3 {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  color: #16a34a;
  border: 1px solid rgba(34, 197, 94, 0.2);
}

.action-section {
  margin-top: 24px;
  padding: 0 16px;
}

:deep(.van-empty__description) {
  color: #64748b;
  font-size: 15px;
}
</style>
